<template>
  <section v-if="!isRegDone" class="form-section">
    <div class="form-section__head">
      <h3>중고폰 판매를 위한 약관 동의</h3>
    </div>
    <div>

      <div class="agree-box mar_b0">
        <h4 class="title mar_b8">[중고폰 판매 계약]</h4>
        <h4 class="title mar_b8 semi_bold">제 1조(목적)</h4>

        <ol class="list">
          <li class="list__item no-bullet">
            <p>
              민팃의 서비스를 이용해 주셔서 감사합니다. 본 약관은 민팃 서비스의 이용과 관련하여 민팃 서비스를 제공하는 민팃 주식회사(이하 "회사")와 이용자간의 관계를 설명하며, 아울러 “회사”의 서비스 이용에 도움이 될 수 있는 유익한 정보를 포함하고 있습니다. <br>
              민팃의 서비스를 이용하거나 민팃 서비스 회원으로 가입하실 경우 여러분은 본 약관 및 관련 운영 정책을 확인하거나 동의하게 되므로, 잠시 시간을 내시어 주의 깊게 살펴봐 주시기 바랍니다. ···
              <span class="color-gray-600">[이하 전문은 <u>자세히 보기</u>에서 확인]</span>
            </p>
          </li>
        </ol>
      </div>
      <div class="check-wrap row agrm-form-input-area weightSB pad_t8 pad_b20 gap_4">
        <DxCheckBox
          class = "semi_bold"
          text="계약서 내용에 동의합니다"
          v-model="chkAgrm1"
          @valueChanged="handleAgrm"
        />
        <span class="font-red">(필수)</span>
        <a class="ui-button__link mar_l0" href="javascript:void(0)" @click.stop="detailPopup()">자세히보기</a>
      </div>
      <div class="agree-box mar_b0">
        <h4 class="title">[개인정보 수집 및 이용 동의]</h4>
        <ol class="list">
          <li class="list__item no-bullet">
            <p>
              <b>“민팃 Home”</b>과 관련하여, 본인의 개인정보를 민팃(주)가 수집 및 이용하는 것에 대해 동의합니다.
            </p>
          </li>
          <li class="list__item">
            <p>
              개인정보의 수집 및 이용 목적 : 중고폰 판매에 따른 대금 지급
            </p>
          </li>
          <li class="list__item">
            <p>
              개인정보의 수집 항목 : (필수) 이름, 은행명, 계좌번호
            </p>
          </li>
          <li class="list__item">
            <p>
              개인정보의 보유 기간 : 거래 완료 후 5년(단 법령에 따라 정한 경우에는 해당 기간까지)
            </p>
          </li>
          <li class="list__item bullet-point">
            <p>
              이 내용은 중고폰 대금 지급을 위한 개인정보 수집·이용에 대한 동의입니다. 동의를 거부할 권리가 있으나, 동의하지 않을 경우에 중고폰 판매가 불가합니다.
            </p>
          </li>
        </ol>
      </div>
      <div class="check-wrap row agrm-form-input-area weightSB pad_t8 pad_b20 gap_4">
        <DxCheckBox
          class = "semi_bold"
          text="개인정보 수집 및 이용에 동의합니다"
          v-model="chkAgrm2"
          @valueChanged="handleAgrm"
        />
        <span class="font-red">(필수)</span>
      </div>
      <div class="agree-box mar_b0">
        <h4 class="title">[중고폰 반품 불가 동의]</h4>
        <ol class="list">
          <li class="list__item">
            <p>
              계좌번호 입력 후 중고폰은 민팃(주)에 귀속되어 반품 신청이 불가함에 동의합니다.
            </p>
          </li>
        </ol>
      </div>
       <div class="check-wrap row agrm-form-input-area weightSB pad_t8 pad_b20 gap_4">
        <DxCheckBox
          class = "semi_bold"
          text="중고폰 반품 불가에 동의합니다"
          v-model="chkAgrm3"
          @valueChanged="handleAgrm"
        />
        <span class="font-red">(필수)</span>
      </div>

      <div class="divider" style="margin: 4px 0 20px"></div>

      <div class="check-wrap row agrm-form-input-area gap_4">
        <DxCheckBox
          text="전체 동의"
          v-model="chkAgrmAll"
          @valueChanged="handleAgrm"
        />
        <span class="font-red">(필수)</span>
      </div>
    </div>
    <NewTermsDetailPopup/>
  </section>
</template>

<script>
import { DxCheckBox } from 'devextreme-vue/check-box'
import NewTermsDetailPopup from './NewTermsDetailPopup.vue'

export default {
  name: 'NewTermsHome',
  components: {
    DxCheckBox,
    NewTermsDetailPopup
  },
  props: ['ordInfo', 'isRegDone', 'isO2o'],
  data: () => ({
    chkAgrm1: false,
    chkAgrm2: false,
    chkAgrm3: false,
    chkAgrmAll: false,
    agrms: {
    	allAgrm: false
    }
  }),
  mounted () {
  },
  computed: {
    isAgreedAll () {
      return [this.chkAgrm1, this.chkAgrm2, this.chkAgrm3].every(v => v)
    }
  },
  created () {},
  watch: {
    isAgreedAll (newVal) {
      this.chkAgrmAll = newVal
    },
    chkAgrmAll (newVal) {
      if (newVal !== this.isAgreedAll) {
        this.chkAgrm1 = newVal
        this.chkAgrm2 = newVal
        this.chkAgrm3 = newVal
      }
      this.agrms.allAgrm = newVal
    },
    agrms: {
      deep: true,
      handler (newVal) {
        this.$emit('aggreAllAgrm', newVal)
      }
    },

  },
  methods: {
  	handleAgrm (e) {

    },
    detailPopup () {
      this.$modal.show('newTermsDetailPopup', {
        detailNum: 100
      })
    }
  }
}
</script>

<style>
	.re-style .form-section .agrm-form-input-area.gap_4 {
		gap : 4px !important;
	}

	.re-style .form-section .font-red {
      justify-content: center;
	    align-items: center;
	    display: flex;
	}

  .cstm_margin{
    margin-bottom:20px !important;
    margin-top:8px !important;
  }

  .gap_4{
    gap:4px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/purchase/home/components/NewTermsHome.vue